import type { RefObject } from "react";
import type { QuickAddCursorState } from "../context/CanvasUiContext";

/** Anchor at a viewport client position (e.g. the rail + button). */
export function buildQuickAddCursorFromClientPos(
  reactFlowWrapperRef: RefObject<HTMLDivElement | null>,
  screenToFlowPosition: (pos: { x: number; y: number }) => {
    x: number;
    y: number;
  },
  clientX: number,
  clientY: number,
): QuickAddCursorState {
  const rect = reactFlowWrapperRef.current?.getBoundingClientRect();

  return {
    // Wrapper-relative coords are only needed for in-canvas anchors; explorer
    // rail opens use client coords + the rail trigger rect instead.
    screenX: rect ? clientX - rect.left : 0,
    screenY: rect ? clientY - rect.top : 0,
    clientX,
    clientY,
    flowPosition: screenToFlowPosition({ x: clientX, y: clientY }),
  };
}
